import { flatMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ofType } from 'redux-observable';

import { showResetPasswordConfirmation } from '../redux/actions';
import { USERS_INITIATE_RESET_PASSWORD_SUCCESS } from '../redux/types';

const resetPasswordEpic = (action$) =>
    action$.pipe(
        ofType(USERS_INITIATE_RESET_PASSWORD_SUCCESS),
        flatMap(() => of(showResetPasswordConfirmation())),
    );

export default resetPasswordEpic;
